import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import PrettoSlider from '../Slider/PrettoSlider';
import Colors from '../../theme/Colors';

const useStyles = makeStyles(theme => ({
  area: {
    paddingTop: theme.spacing(3),
  },
  textField: {
    backgroundColor: '#0e0e0e',
    padding: '5px 20px',
    marginTop: 20,
    borderRadius: 5,
    border: '1px solid #931b28',
    '& input': {
      color: Colors.subTextColor,
      fontSize: 14,
      '&::placeholder': {
        color: Colors.white,
      },
    },
    '&::before, &::after': {
      display: 'none',
    },
  },
  root: {
    color: '#636363',
  },
  variableClick: {
    color: Colors.white,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

const StreamConfigAlertsGeneralSettings = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { maxLevelCard, showMinLevelAlerts, handleChange, minLevel, customMsg } = props;

  let levelRevolution = t('rareness_level.1')

  if (minLevel === 2) levelRevolution = t('rareness_level.2')
  else if (minLevel === 3) levelRevolution = t('rareness_level.3')
  else if (minLevel === 4) levelRevolution = t('rareness_level.4')
  else if (minLevel === 5) levelRevolution = t('rareness_level.5')

  const addVariable = (variable) => {
    handleChange(null, 'customMsg', customMsg + ' ' + variable);
  };

  return (
    <div className={classes.root}>
      <FormControlLabel
        labelPlacement="start"
        style={{ marginLeft: 0, marginRight: 0 }}
        control={
          <Switch
            checked={showMinLevelAlerts}
            onChange={() => handleChange(null, 'showMinLevelAlerts', !showMinLevelAlerts)}
            value={showMinLevelAlerts} />
        }
        label={t('show_level_card_alert')}
      />
      {(showMinLevelAlerts && minLevel > 0) &&
      <div className={classes.area}>
        <Typography id="discrete-slider" variant="body1" gutterBottom>
          {t('from_level_card_alert', { level: levelRevolution })}
        </Typography>
        <PrettoSlider
          value={minLevel}
          aria-labelledby="discrete-slider"
          valueLabelDisplay="auto"
          onChange={(event, newValue) => handleChange(event, 'minLevel', newValue)}
          marks
          step={1}
          min={1}
          max={maxLevelCard}
        />
        <Typography
          variant="h3"
          gutterBottom
          style={{ textTransform: 'none', marginTop: 20, color: Colors.white, fontWeight: 400 }}
        >
          {t('fit_custom_alert_msg')}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {t('custom_alert_msg_variables_text')}<br />
          <span className={classes.variableClick} onClick={() => addVariable('%USER%')}>
            %USER%
          </span> = {t('custom_alert_msg_username')}
          <br />
          <span className={classes.variableClick} onClick={() => addVariable('%RARITY%')}>
            %RARITY%
          </span> = {t('custom_alert_msg_level')}
        </Typography>
        <TextField
          style={{ width: '100%' }}
          disableUnderline
          value={customMsg}
          InputProps={{
            classes: { root: classes.textField },
          }}
          onChange={(event) => handleChange(event, 'customMsg', event.target.value)}
          placeholder={t('custom_alert_msg_placeholder')} />
      </div>
      }
    </div>
  );
};

export default StreamConfigAlertsGeneralSettings;